// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"78":"safety-handbbok","490":"supplier-responsibility","537":"procurement-post","596":"404","693":"apply-procurement","887":"procurement"}[chunkId] + "." + {"78":"65dafc7e","490":"05c60f90","537":"34f6a34e","596":"c92d05ad","693":"84286db7","887":"fc615fdb"}[chunkId] + ".css";
};